/**
 * glass-collections.js
 * Enhances collection pages with:
 *  - Glass thickness badge extracted from product title
 *  - "Configure & Order" CTA button on each card
 *  - Price suffix "/m² exc. VAT" on product card prices
 */

(function () {
  'use strict';

  /**
   * Extracts the glass thickness string from a product title.
   * Matches patterns like "10mm", "6.4mm", "12 mm", "6/6mm"
   * Returns the matched string or null.
   */
  function extractThickness(text) {
    if (!text) return null;
    var match = text.match(/\b(\d+(?:[./]\d+)?)\s*mm\b/i);
    return match ? match[0].replace(/\s+/, '') : null;
  }

  /**
   * Enhances a single product grid item with badge and CTA.
   */
  function enhanceItem(item) {
    if (item.dataset.glassEnhanced) return;
    item.dataset.glassEnhanced = 'true';

    // ---- Thickness Badge ----
    var cardGallery = item.querySelector('.card-gallery');
    if (cardGallery) {
      // Try to find title text — check the product title link or any <p> in the card
      var titleEl = item.querySelector('a.contents p, [ref="productTitleLink"] p, .product-card__content p');
      var thickness = null;

      if (titleEl) {
        thickness = extractThickness(titleEl.textContent);
      }

      // Fallback: search all text in the card
      if (!thickness) {
        thickness = extractThickness(item.textContent);
      }

      if (thickness && !cardGallery.querySelector('.glass-thickness-badge')) {
        var badge = document.createElement('span');
        badge.className = 'glass-thickness-badge';
        badge.textContent = thickness;
        cardGallery.appendChild(badge);
      }
    }

    // ---- Price Suffix: /m² exc. VAT ----
    var priceEls = item.querySelectorAll('product-price .price');
    priceEls.forEach(function (priceEl) {
      if (!priceEl.querySelector('.gc-price-suffix')) {
        var suffix = document.createElement('span');
        suffix.className = 'gc-price-suffix';
        suffix.textContent = '/m\u00B2 exc. VAT';
        priceEl.appendChild(suffix);
      }
    });

    // ---- Configure & Order Button ----
    var cardContent = item.querySelector('.product-card__content');
    if (cardContent && !cardContent.querySelector('.glass-configure-btn')) {
      // Get the product URL from the hidden link at the top of the card
      var productLink = item.querySelector('.product-card__link');
      var href = productLink ? productLink.getAttribute('href') : null;

      if (href) {
        var btn = document.createElement('a');
        btn.className = 'glass-configure-btn';
        btn.href = href;
        btn.textContent = 'Configure & Order';
        btn.setAttribute('aria-label', 'Configure and order this product');
        // Prevent click bubbling to the card link
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
        });
        cardContent.appendChild(btn);
      }
    }
  }

  /**
   * Enhance all visible product grid items.
   */
  function enhanceAll() {
    var items = document.querySelectorAll('.product-grid__item');
    items.forEach(enhanceItem);
  }

  /**
   * Observe the grid for dynamically loaded items (infinite scroll).
   */
  function observeGrid() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    var observer = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (hasNewNodes) {
        // Short delay to allow Shopify to finish rendering
        setTimeout(enhanceAll, 150);
      }
    });

    observer.observe(grid, { childList: true, subtree: false });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceAll();
      observeGrid();
    });
  } else {
    // Already loaded
    enhanceAll();
    observeGrid();
  }
})();

